import React, { useMemo, useState } from 'react';
import { Col, Row } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import SteamGameStore from '../components/SteamGameStore';
import SteamScoreTrendBox from '../../gamestore/widgets/ScoreTrendsPcConsole/SteamScoreTrendBox';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { steamPerformanceFilteredReviewsTips } from '@/pages/opinion/components/BubbleCommon';
import '@/pages/opinion/assets/scss/pages/feeds/GameStore.scss';
import '../scss/SteamFilteredReviews.scss';
import { barLineIcon, tableIcon, commonBarTHIcon } from '@op/constants/chart';
import { ReviewsTable } from '../components/ReviewsTable';
import { dealwithFilteredReviewsTableData } from '../utils';
import { downloadAction } from '@op/components/DownloadCommon/download-page';

export default function SteamFilteredReviews({
  userScore = {},
  timeline = {},
  timelineLoading,
  loading,
  filter,
}: any) {
  const [chartType, setChartType] = useState('bar-line');
  const allNoData = useMemo(() => {
    const { list } = userScore?.steam || { list: {} };

    const useScoreNoData = [
      'select_all_review',
      'select_non_recommend',
      'select_recommend',
    ].every((key) => {
      const item = list?.[key] || { review: 0, score: 0 };
      return item.review === 0 && item.score === 0;
    });

    const { list: timelineList } = timeline?.steam || { list: {} };

    const scoreTrendNoData = [
      'all_reviews',
      'select_non_recommend',
      'select_recommend',
      'select_recommend_score',
    ].every((key) => {
      const item = timelineList?.[key] || [];
      return item.length === 0;
    });

    return useScoreNoData && scoreTrendNoData;
  }, [userScore, timeline]);

  const tableData = useMemo(() => {
    return dealwithFilteredReviewsTableData(timeline?.steam?.list);
  }, [timeline]);

  function downloadReviewsInfo() {
    downloadAction({
      limit: 150000,
      downLoadParams: {
        ...filter,
        channel: ['steam'],
        channels: ['steam'],
        metrics: ['recommend', 'non_recommend'],
        ret_metrics: ['recommend', 'non_recommend'],
        types: ['total', 'slice'],
      },
      downloadFunc: 'getOverviewPcConsoleTimeline',
      simpleName: 'Added Reviews',
      sheetName: 'Added Reviews',
    });
  }

  return (
    <CardCommon
      className="steam-selected-reviews-wrapper"
      loading={loading || timelineLoading}
      empty={allNoData}
      emptyHeight={300}
      loadingHeight={300}
    >
      <Row>
        <Col span={24}>
          <SteamGameStore
            title={'Added Reviews'}
            keys={[
              'select_all_review',
              'select_non_recommend',
              'select_recommend',
            ]}
            titleIconEle={
              <SvgIcon className="title-icon-info" type="new-logo"></SvgIcon>
            }
            nearTotalTips={steamPerformanceFilteredReviewsTips}
            filter={filter}
            showShare={false}
            isSelected={true}
            span={15}
            showRatingView={chartType !== 'table'}
            defaultOperation={chartType}
            data={userScore.steam || {}}
            operations={[barLineIcon, commonBarTHIcon, tableIcon]}
            handleOperationsOnClick={(value: any) => setChartType(value.symbol)}
            hasDownload
            handleDownloadOnClick={downloadReviewsInfo}
          ></SteamGameStore>
          {chartType === 'table' ? (
            <ReviewsTable
              filter={filter}
              recordKey="time"
              records={tableData}
              height={340}
              columns={[
                { text: 'Date', value: 'time', isDate: true, align: 'left' },
                { text: 'Positive', value: 'select_recommend' },
                { text: 'Negative', value: 'select_non_recommend' },
                {
                  text: 'Positive%',
                  value: 'select_recommend_score',
                  isScore: true,
                },
              ]}
            ></ReviewsTable>
          ) : (
            <SteamScoreTrendBox
              platformData={timeline?.steam}
              filterParams={filter}
              loading={timelineLoading}
              negativeLessThanZero={chartType === 'common-th-bar'}
              // otherKeyMetrics={[
              //   {
              //     text: 'Lifetime Added Reviews Positive%',
              //     key: 'all_reviews',
              //     type: 'line',
              //     color: '#92DEB4',
              //     valueKey: 'score',
              //     sort: 1.5,
              //     lineStyle: { type: 'dashed' },
              //     decimalDigit: 0
              //   },
              // ]}
            ></SteamScoreTrendBox>
          )}
        </Col>
      </Row>
    </CardCommon>
  );
}
